export enum EditableType {
	ALL,
	ONLYNEW,
	NONE
}
